import { f as filterProps } from './utils-b0152686-02a2d19d.js';
import { a as IntlFormatError } from './error-9e87f495-aa7226e5.js';
import { F as FormatError, E as ErrorCode } from '../../../../intl-messageformat/lib/src/error-60947bc5-5d86a490.js';

var PLURAL_FORMAT_OPTIONS = ['type'];
function formatPlural(_a, getPluralRules, value, options) {
  var locale = _a.locale,
    onError = _a.onError;
  if (options === void 0) {
    options = {};
  }
  if (!Intl.PluralRules) {
    onError(new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", ErrorCode.MISSING_INTL_API));
  }
  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  try {
    return getPluralRules(locale, filteredOptions).select(value);
  } catch (e) {
    onError(new IntlFormatError('Error formatting plural.', locale, e));
  }
  return 'other';
}

export { formatPlural as f };
//# sourceMappingURL=plural-385ae41f-94736942.js.map
